import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/customizable-closet-actions";

const customizableClosetReducer = (state = INITIAL_STATE.customizableCloset, action) => {
  switch (action.type) {
    case TYPES.SET_CUSTOMIZABLE_CLOSET: {
      return {
        ...state,
        currentCloset: action.customizableCloset,
      };
    }

    case TYPES.PUT_CUSTOMIZABLE_CLOSET: {
      return {
        ...state,
        currentCloset: action.customizableCloset,
      };
    }

    case TYPES.PUT_SELECTED_ITEM: {
      const closetItems = state.currentCloset.closet_items.filter(
        (ci) => ci.product.id !== action.selectedItem.product.id,
      );
      const newClosetItems = [...closetItems, action.selectedItem];
      return {
        ...state,
        currentCloset: {
          ...state.currentCloset,
          closet_items: newClosetItems,
        },
      };
    }

    case TYPES.UPDATE_ANTICIPATED_ADD_ON_COUNT: {
      return {
        ...state,
        anticipatedAddOnCount: action.anticipatedAddOnCount,
      };
    }

    case TYPES.UPDATE_ANTICIPATED_ADD_ON_ERROR: {
      return {
        ...state,
        anticipatedAddOnError: action.anticipatedAddOnError,
      };
    }

    default:
      return state;
  }
};

export default customizableClosetReducer;
